export default __webpack_public_path__ + "static/media/homeWeb.58a59e87.png";